// extracted by mini-css-extract-plugin
export default {"defaults":"TextArea_defaults__vhpu8","big":"TextArea_big__qBjGn","small":"TextArea_small__53hKH"};